module.exports = __webpack_public_path__ + "media/share.72965f11.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/app-website/assets/share.svg
// module id = ./src/templates/app-website/assets/share.svg
// module chunks = 0